export default {
  BASE_URL: '/admin/cms/param',
  api: [
    /** 参数管理 */
    {
      name: 'listTypes',
      desc: '参数类目',
      method: 'GET',
      path: '/listTypes'
    },
    {
      name: 'listConfigs',
      desc: '参数列表',
      method: 'GET',
      path: '/listConfigs'
    },
    {
      name: 'getConfig',
      desc: '参数详情',
      method: 'GET',
      path: '/getConfig/{id}'
    },
    {
      name: 'openOrCloseParam',
      desc: '停用/启用',
      method: 'PUT',
      path: '/openOrCloseParam'
    },
    {
      name: 'saveOrModifyParam',
      desc: '添加/编辑',
      method: 'POST',
      path: '/saveOrModifyParam'
    },
    {
      name: 'delParam',
      desc: '删除',
      method: 'PUT',
      path: '/delParam/{id}'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/cms/params.js